import { render, staticRenderFns } from "./Rentabilidade.vue?vue&type=template&id=f5f1526c&scoped=true&"
import script from "./Rentabilidade.vue?vue&type=script&lang=js&"
export * from "./Rentabilidade.vue?vue&type=script&lang=js&"
import style0 from "./Rentabilidade.vue?vue&type=style&index=0&id=f5f1526c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f1526c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VProgressCircular})
